module.exports = __webpack_public_path__ + "img/group-line.d28fad0f.svg";